export function Success({ redirecting = false }: { redirecting?: boolean }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-100 p-8 text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-green-50 rounded-full mx-auto mb-6">
          <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">¡Pago exitoso!</h2>
        {redirecting ? (
          <>
            <p className="text-gray-500">Redirigiendo a la tienda...</p>
            <div className="mt-4">
              <div className="w-6 h-6 border-2 border-gray-300 border-t-green-600 rounded-full animate-spin mx-auto" />
            </div>
          </>
        ) : (
          <p className="text-gray-500">Tu pago ha sido procesado exitosamente.</p>
        )}
      </div>
    </div>
  );
}
